<template>
  <b-modal
    id="reject-modal"
    modal-class="timesheet-modal"
    title="Reject Timesheet"
    ok-title="Confirm"
    @ok="$emit('ok', $event)"
    @hidden="$emit('hidden')"
  >
    <b-form-group label="Rejection reason (optional)">
      <b-form-input
        v-model="form.adminComment"
        placeholder="e.g. Times don't match site records"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'TimesheetRejectModal',
  props: {
    form: { type: Object, required: true },
  },
}
</script>
